<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>
<script>
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive=true
      })
    }
  }
}
</script>
<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  font-size: 0;
  outline: 0;
  width: 100%;
  height: 100%;
}

#app {
  height: 100%;
  min-width: 960px;
}
</style>
